/* eslint-disable no-restricted-globals */
// eslint-disable-next-line
// @ts-nocheck
import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import Box from '@mui/material/Box';
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Modal,
  Switch,
  Grid,
  CardContent,
} from '@mui/material';
// components
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import AllParkingsListHead from '../../sections/@dashboard/bookings/AllParkingsListHead';
import Loading from '../../components/Loading';
import toast from 'react-hot-toast';
import { checkPermissions } from '../../sections/@dashboard/parkingspaces/utility';
import { PERMISSION } from '../../utils/userPermission';
import { useDeleteQueryContactMutation, useFindAllQueryContactMutation } from '../../store/api/contactSupportApi';
import {
  getContactSupport,
  getContactSupportTotalRecords,
  setContactSupport,
} from '../../store/state/contactSupportSlice';
import { BookingListToolbar } from '../../sections/@dashboard/bookings';

const TABLE_HEAD = [
  { id: 'name', label: 'Customer Name', alignRight: false },
  { id: 'email', label: 'Customer Email', alignRight: false },
  { id: 'phoneNo', label: 'Phone Number', alignRight: false },
  { id: 'contactType', label: 'Issue Category', alignRight: false },
  { id: 'description', label: 'Issue Details', alignRight: false },
  { id: 'status', label: 'Resolution Taken', alignRight: false },
];

export default function CustomerSupport() {
  const dispatch = useAppDispatch();
  const token = JSON.parse(localStorage.getItem('login') || '{}') || null;
  const [findAllQueryContact, findAllQueryContactResponse] = useFindAllQueryContactMutation();
  const [deleteQueryContact, deleteQueryContactResponse] = useDeleteQueryContactMutation();
  const [customerDetail, setCustomerDetails] = useState([]);
  const filteredUsers = customerDetail;
  const contactSupportTotalRecords = useAppSelector(getContactSupportTotalRecords);
  const ContactSupportData = useAppSelector(getContactSupport);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selected, setSelected] = useState([]);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('id');
  const [open, setOpen] = useState(false);
  const [customerId, setCustomerId] = useState<number>();
  const [filterName, setFilterName] = useState('');

  // findAllQueryContact
  useEffect(() => {
    if (ContactSupportData) {
      setCustomerDetails(ContactSupportData);
    }
  }, [ContactSupportData]);

  useEffect(() => {
    findAllQueryContact({
      token: token.token,
      payload: {
        limit: rowsPerPage,
        pageNo: page,
        name: name,
      },
    });
  }, []);

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
      findAllQueryContact({
        token: token.token,
        payload: {
          limit: rowsPerPage,
          pageNo: page,
          name: event.target.value,
        },
      });
  };

  useEffect(() => {
    if (findAllQueryContactResponse.isSuccess) {
      dispatch(setContactSupport(findAllQueryContactResponse.data));
    }
    if (findAllQueryContactResponse.isError) {
      let errorData: any = findAllQueryContactResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [findAllQueryContactResponse.isSuccess, findAllQueryContactResponse.isError]);

  const handleDelete = () => {
    setOpen(false);
    deleteQueryContact({
      id: customerId,
      token: token.token,
    });
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const cancelDelete = () => {
    setOpen(false);
  };

  // pagination
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = serviceProviders.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  // deleteQueryContact
  useEffect(() => {
    if (deleteQueryContactResponse.isSuccess) {
      findAllQueryContact({
        token: token.token,
        payload: {
          limit: rowsPerPage,
          pageNo: page,
          name: name,
        },
      });
      toast.success('Customer updated successfully.');
    } else if (deleteQueryContactResponse.isError) {
      let errorData: any = deleteQueryContactResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong. ' + msg || '');
    }
  }, [deleteQueryContactResponse.isSuccess, deleteQueryContactResponse.isError]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
    findAllQueryContact({
      token: token.token,
      payload: {
        limit: rowsPerPage,
        pageNo: newPage,
        name: name,
      },
    });
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    findAllQueryContact({
      token: token.token,
      payload: {
        limit: parseInt(event.target.value, 10),
        pageNo: 0,
        name: name,
      },
    });
  };

  // style
  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '30px',
    px: '50px',
  };

  return (
    <Page title="Customer Support Overview">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" marginBottom={'25px'}>
          <Typography variant="h4" gutterBottom>
            Customer Support Overview
          </Typography>
        </Stack>
        <Card>
          <Scrollbar>
            <BookingListToolbar
              numSelected={selected.length}
              filterName={filterName}
              onFilterName={handleFilterByName}
              placeholder={'Search By Customer Name'}
            />
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <AllParkingsListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={customerDetail.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.length > 0 &&
                    filteredUsers.map((row) => {
                      const { id, name, email, phoneNo, contactType, description, status } = row;
                      const isItemSelected = selected.indexOf(name) !== -1;
                      return (
                        <TableRow
                          hover
                          key={id.toString()}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell>
                            <Typography fontWeight="normal" variant="subtitle2">
                              {name ? name : '_'}
                            </Typography>
                          </TableCell>

                          <TableCell align="left">
                            <Typography fontWeight="normal" variant="subtitle2">
                              {email ? email : '_'}
                            </Typography>
                          </TableCell>

                          <TableCell align="left">
                            <Typography fontWeight="normal" variant="subtitle2">
                              {phoneNo ? phoneNo : '_'}
                            </Typography>
                          </TableCell>

                          <TableCell align="left">
                            <Typography fontWeight="normal" variant="subtitle2">
                              {contactType ? contactType : '_'}
                            </Typography>
                          </TableCell>

                          <TableCell align="left">
                            <Typography fontWeight="normal" variant="subtitle2">
                              {description ? description : '_'}
                            </Typography>
                          </TableCell>

                          <TableCell align="left">
                            <Stack direction="row" alignItems="center">
                              <Switch
                                checked={status}
                                disabled={checkPermissions(PERMISSION.CUSTOMER_VIEW, token.permissions)}
                                onClick={() => {
                                  setCustomerId(id);
                                  handleOpen();
                                }}
                              />
                            </Stack>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
              {filteredUsers.length == 0 ? (
                <Grid container direction="row" justifyContent="space-evenly" alignItems="center">
                  <Card sx={{ width: 1 }}>
                    <CardContent>
                      <Typography gutterBottom align="center" variant="subtitle1">
                        No record found!!!{' '}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ) : (
                ''
              )}
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={contactSupportTotalRecords || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
        {open && (
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography id="modal-modal-title" textAlign={'center'} variant="h4" gutterBottom>
                Are you sure?
              </Typography>
              <Stack direction="row" justifyContent={'center'} alignItems={'center'}>
                <Button
                  variant="contained"
                  onClick={cancelDelete}
                  sx={{ margin: '10px', backgroundColor: '#E23744' }}
                  color="error"
                >
                  No
                </Button>
                <Button
                  variant="contained"
                  onClick={handleDelete}
                  sx={{ margin: '10px', backgroundColor: '#E23744' }}
                  color="error"
                >
                  Yes
                </Button>
              </Stack>
            </Box>
          </Modal>
        )}
        {findAllQueryContactResponse.isLoading || deleteQueryContactResponse.isLoading ? <Loading /> : null}
      </Container>
    </Page>
  );
}
